import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Table from "../../../core/pagination/datatable";
import { Select, Spin } from "antd";
import { GET_SCHEDULE, getApiBaseUrl } from "../Config/Config";

const { Option } = Select;

const Schedule = () => {
  const [schedules, setSchedules] = useState([]);
  const [loading, setLoading] = useState(false);
  const [blocks, setBlocks] = useState([]);
  const [selectedBlockId, setSelectedBlockId] = useState(0);
  console.log(selectedBlockId, "ssssssssss");
  const fetchSchedules = async () => {
    setLoading(true);
    try {
      const response = await fetch(
        `${getApiBaseUrl()}${GET_SCHEDULE}?BlockId=${selectedBlockId}`
      );
      const result = await response.json();

      if (result?.Status && Array.isArray(result?.ResultData)) {
        setSchedules(result.ResultData);
      } else {
        console.error("Unexpected API format:", result);
        setSchedules([]);
      }
    } catch (error) {
      console.error("Failed to fetch schedules:", error);
      setSchedules([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSchedules();
  }, [selectedBlockId]);

  useEffect(() => {
    const fetchBlocks = async () => {
      try {
        const res = await fetch(`${getApiBaseUrl()}/api/getLocationType`);
        const data = await res.json();
        if (data?.Status !== false && Array.isArray(data?.ResultData)) {
          setBlocks(data.ResultData);
        }
      } catch (error) {
        console.error("Error fetching blocks:", error);
      }
    };

    fetchBlocks();
  }, []);

  const columns = [
    {
      title: "Filter ID",
      dataIndex: "Lable",
      key: "Lable",
    },
    {
      title: "Last Cleaning Date",
      dataIndex: "LastCleaningDate",
      key: "LastCleaningDate",
      render: (date) => {
        if (!date) return "N/A";

        const d = new Date(date);
        const day = String(d.getDate()).padStart(2, "0");
        const month = String(d.getMonth() + 1).padStart(2, "0");
        const year = d.getFullYear();

        // if 01/01/1900 → treat as invalid
        if (day === "01" && month === "01" && year === 1900) {
          return "N/A";
        }

        // const hours = String(d.getHours()).padStart(2, "0");
        // const minutes = String(d.getMinutes()).padStart(2, "0");
        return `${day}/${month}/${year} `;
      },
    },
    // {
    //   title: "Installed On",
    //   dataIndex: "InstalledOn",
    //   key: "InstalledOn",
    //   render: (date) => (date ? dayjs(date).format("DD/MM/YYYY") : "-"),
    // },
    {
      title: "Block",
      dataIndex: "locatinname",
      key: "locatinname",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (value) => {
        const statusMap = {
          1: "Pending",
          2: "In Progress",
          3: "Completed",
        };
        return statusMap[value] || "Unknown";
      },
    },
  ];

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="page-title">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/assetmgt/dashboard">
                      <i className="fas fa-home fa-lg" />
                    </Link>
                  </li>
                  <h4 className="breadcrumb-item " aria-current="page">
                    Schedule
                  </h4>
                </ol>
              </nav>
              <h6>Manage Filters Cleaning Schedule</h6>
            </div>
          </div>
          <ul className="table-top-head">
            <li></li>
          </ul>
        </div>

        <div className="card table-list-card">
          <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3  ">
            <div className="search-set m-3"></div>
            <div className="d-flex table-dropdown my-xl-auto right-content align-items-center flex-wrap row-gap-3">
              <div className="d-flex flex-column me-3">
                <label className="form-label mb-1">Blocks</label>
                <Select
                  placeholder="Select Block"
                  style={{ width: 200 }}
                  onChange={(value) => setSelectedBlockId(value)}
                  value={selectedBlockId}
                >
                  <Option value={0}>All</Option>
                  {blocks.map((block) => (
                    <Option key={block.BlockId} value={block.BlockId}>
                      {block.BlockName}
                    </Option>
                  ))}
                </Select>
              </div>
            </div>
          </div>
          <div className="card-body">
            <div className="table-responsive">
              {loading ? (
                <div className="text-center my-4">
                  <Spin size="large" />
                  <p>Loading data...</p>
                </div>
              ) : schedules.length > 0 ? (
                <Table columns={columns} dataSource={schedules} />
              ) : (
                <p className="text-center my-4">No data available</p>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Schedule;
